import { headers } from './orderRepository'
import { getClientCustomFetch } from '../lib/getClientCustomFetch'
import encodedURIComponentQueryStringConverter from '../utils/encodedURIComponentQueryString'

const getWishlistProducts = async (data = {}) => {
  const customFetch = await getClientCustomFetch()
  const response = await customFetch.get(
    encodedURIComponentQueryStringConverter('/wish-list', { ...data?.params }))
  return response?.data
}

const getWishlistProductById = async (data = {}) => {
  const customFetch = await getClientCustomFetch()
  const { id = '' } = data
  const response = await customFetch.get(`/wish-list/${id}`, { headers: headers() })
  return response?.data
}

const addProductIntoWishlist = async (data = {}) => {
  const customFetch = await getClientCustomFetch()
  const response = await customFetch.post('/wish-list/default/product', {
    ...data,
  })
  return response?.data
}

const deleteProductFromWishlist = async (data = {}) => {
  const customFetch = await getClientCustomFetch()
  const response = await customFetch.delete('/wish-list/default/product', {
    data,
  })
  return response?.data
}

export {
  getWishlistProducts,
  addProductIntoWishlist,
  deleteProductFromWishlist,
  getWishlistProductById,
}
